import React from "react";
import { Instagram, Facebook, Youtube, Twitter, Mail } from "lucide-react";
import { FOOTER_LINKS } from "../mock";

const Footer = () => {
  return (
    <footer className="bg-[#1A1410] text-[#FFF2EC]">
      <div className="max-w-7xl mx-auto px-4 py-14 md:py-20">
        <div className="grid lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <div className="font-serif-display text-4xl md:text-5xl font-bold italic tracking-tight">
              GVB
            </div>
            <div className="font-display text-[10px] tracking-[0.35em] uppercase text-[#DD4D2A] mt-1">
              George Venture Brands
            </div>
            <p className="mt-5 text-sm text-[#FFF2EC]/70 max-w-md leading-relaxed">
              Premium fitness rebounders engineered to help you move better,
              feel better, and live better. Backed by a 30-day money-back
              guarantee.
            </p>
            <div className="mt-6 flex items-center gap-3">
              {[Instagram, Facebook, Youtube, Twitter].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  aria-label="social"
                  className="w-10 h-10 rounded-full bg-white/5 hover:bg-[#DD4D2A] border border-white/10 flex items-center justify-center transition-colors"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {Object.entries(FOOTER_LINKS).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-semibold text-sm uppercase tracking-wider mb-4">
                {title}
              </h4>
              <ul className="space-y-2.5">
                {links.map((l) => (
                  <li key={l}>
                    <a
                      href="#"
                      className="text-sm text-[#FFF2EC]/65 hover:text-[#FFB89E] transition-colors"
                    >
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-[#FFF2EC]/50">
            © {new Date().getFullYear()} George Venture Brands. All rights
            reserved.
          </p>
          <div className="flex items-center gap-2 text-xs text-[#FFF2EC]/50">
            <Mail className="w-3.5 h-3.5" />
            info@georgeventurebrands.com
          </div>
          <div className="flex items-center gap-2">
            {["VISA", "MC", "AMEX", "PayPal", "Apple Pay"].map((p) => (
              <span
                key={p}
                className="text-[10px] font-bold px-2 py-1 bg-white/10 rounded"
              >
                {p}
              </span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
